/* eslint-disable max-lines */
const Layout = () => import(/* webpackChunkName: "pages/main" */ 'layout');
const Construction = () => import(/* webpackChunkName: "pages/views" */ 'views/Construction');
const Legal = () => import(/* webpackChunkName: "pages/views" */ 'views/Legal');
const Page404 = () => import(/* webpackChunkName: "pages/views" */ 'views/Error');

export default [
  {
    path: '/',
    component: Layout,
    children: [
      {
        path: '',
        name: 'construction',
        component: Construction,
        meta: { titleKey: 'construction' }
      },
      {
        path: '/:type',
        name: 'legal',
        component: Legal
      },
      {
        path: '*',
        name: '404',
        component: Page404,
        meta: {
          titleKey: 'error404'
        }
      }
    ]
  }
];
